import React, { useEffect, useState } from "react";

import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";
import { IoMdCloseCircle } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { useStateContext } from "../../../../../contexts/ThemeContext";

import { ReactComponent as TrashIcon } from "../../../../../assets/dashboard/link/trashIcon.svg";
import { ReactComponent as TrashIconDark } from "../../../../../assets/dashboard/link/trashIcon-dark.svg";

import { ReactComponent as ImagePlacholder } from "../../../../../assets/dashboard/avatar/gallery.svg";
import { ReactComponent as ImagePlacholderDark } from "../../../../../assets/dashboard/avatar/gallery-dark.svg";
import { ReactComponent as DownArrow } from "../../../../../assets/settingPage/arrow-down.svg";

import { useDispatch, useSelector } from "react-redux";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import {
  gettingImageGrid,
  griImgList,
  reset,
} from "../../../../../redux/slices/imageGrid/ImageGridSlice";
import { toast } from "react-hot-toast";
import { FileUploader } from "react-drag-drop-files";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";
import i18nForComponent from "../../../../../locales/component/i18nForComponent";
import { I18nextProvider } from "react-i18next";

const fileTypes = ["png", "jpg", "jpeg", "gif", "ico"];

const ImageGrid = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate, allLangs, tComponent, handleLanguageChange } =
  useLocales();
  const { themeDirection } = useSettings();
  const { setActiveMainPageNav } = useStateContext();
  const [files, setFiles] = useState([]);
  const [imageLoading, setImageLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectReporterTypeDropDown, setSelectReporterTypeDropDown] =
    useState(false);
  const [selectedReporterType, setSelectedReporterType] = useState("English");
  const [selectedLang, setSelectedLang] = useState("en");

  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedLang) {
      handleLanguageChange(selectedLang);
    }
  }, [selectedLang])

  const blockFeature = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.response
  );
  const paymenetBlocks = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.paymenet_blocks
  );
  // Image Grid
  const imageGridCheck = blockFeature?.some(
    (item) => item.name === "image_grid" && paymenetBlocks === 1
  );
  useEffect(() => {
    if (!imageGridCheck) {
      navigate("/pricing");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (file) => {
    // console.log(file, "fiels imageGrid");
    setFiles((prevFiles) => {
      const prevLength = prevFiles?.length;
      const newLength = file?.length;
      // console.log(prevLength, newLength);
      if (prevLength + newLength <= 4) {
        return [...prevFiles, ...file];
      } else {
        let newArray = [...file];
        newArray = newArray.splice(0, 4 - prevLength);
        return [...prevFiles, ...newArray];
      }
    });
  };

  const removeImage = (file) => {
    setFiles((prevsFiles) =>
      prevsFiles.filter((item) => {
        return item !== file;
      })
    );
  };

  const handleSubmit = async () => {
    setImageLoading(true);

    const linkid = localStorage.getItem("linkId");
    const userID = JSON.parse(localStorage.getItem("user")).userid;
    const data = {
      coloum_name: "imageGrid",
      coloum_type: "imageGrid",
      picture: [...files],
      link_id: linkid,
      user_id: userID,
      id: 0,
      language: selectedLang,
    };

    await dispatch(gettingImageGrid(data)).then(() => {
      fetchingLinksList(); // fetching link list after submiting , so list become refresh
    });

    setFiles([]);
    setImageLoading(false);
  };

  //  fetching link list after submiting, so list become refresh
  function fetchingLinksList() {
    // data need for fetching link list
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user.userid;
    const usertoken = user.token;
    const linkId = localStorage.getItem("linkId");
    const linkListData = {
      userId,
      usertoken,
      linkId,
    };
    dispatch(gettingLinkList(linkListData));
  }

  const imgGridData = useSelector(griImgList);
  console.log(
    "const imgGridData = useSelector(griImgList);",
    useSelector(griImgList)
  );
  const { status, message } = imgGridData?.imageGridCard?.getImageGrid;
  const { getImageGridSuccess, getImageGridError } = imgGridData?.imageGridCard;

  useEffect(() => {
    if (status === "success" && getImageGridSuccess) {
      toast.success("Image Grid Block added");
      navigate("/dashboard");
    }
    if (status === "failed" && getImageGridSuccess) {
      toast.error(message);
    }

    dispatch(reset());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getImageGridSuccess, getImageGridError]);

  
  const handleChangeLang = (newLang) => {
    handleLanguageChange(newLang);
  };


  return (
    <I18nextProvider i18n={i18nForComponent}>
    <>
      <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
        <Link to={"/dashboard/component"}>
          <div className="flex text-body_copy2 items-center cursor-pointer text-heading_color gap-2">
            <div>
              {darkMode ? (
                <LeftArrowDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </div>
            <p className="dark:text-color_v1_dark">
              {translate("image_grid")}
            </p>
          </div>
        </Link>
      </div>
      <div className="sm:mt-7 md:px-0 mt-10 mb-6 px-6"   style={{
              direction: selectedLang === "ar" ? "rtl" : "ltr",
            }}>
        <div className="border rounded-lg bg-light_bg_v5 dark:bg-dark-secondary p-[25px] dark:border-color_dark">
          <div className="flex justify-between items-center mb-[20px] sm:mb-[25px]">
            <p className="text-small2_b sm:text-small1_bold text-heading_color dark:text-color_v1_dark uppercase">
              {tComponent("imagegrid.add_image_grid")} &nbsp;
              <span className="text-small2 text-dark_bg_v5 dark:text-color_v1_dark capitalize">
                ({tComponent("imagegrid.maximum")} 4)
              </span>
            </p>
            <div className="flex items-center justify-center">
                  <div className="relative w-[115px] sm:w-[145px]">
                    <div
                      onClick={() => {
                        setSelectReporterTypeDropDown(
                          !selectReporterTypeDropDown
                        );
                      }}
                      className={`bg-light_bg_v4 capitalize p-[13px] text-small2 lg:text-body_copy2 rounded-md w-full flex justify-between items-center cursor-pointer`}
                    >
                      {selectedReporterType
                        ? selectedReporterType
                        : tComponent("imagegrid.select_lang")}
                      <DownArrow />
                    </div>
                    {selectReporterTypeDropDown && (
                      <div className="absolute top-14 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5  rounded-lg border flex flex-col max-h-40 overflow-y-auto">
                        {allLangs?.map((item, i) => {
                          return (
                            <div
                              key={i}
                              onClick={() => {
                                setSelectedLang(item.value); // Set selected language code
                                setSelectedReporterType(item?.label);
                                setSelectReporterTypeDropDown(false);
                                handleChangeLang(item?.value);
                              }}
                              className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md"
                            >
                              {item.label}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
          </div>

          {files.length < 4 && (
            <FileUploader
              handleChange={handleChange}
              name="file"
              types={fileTypes}
              maxSize={2}
              onSizeError={(errorMessage) => toast.error(errorMessage)}
              onTypeError={(errorMessage) => toast.error(errorMessage)}
              multiple={true}
              children={
                <div>
                  <div className="flex items-center justify-center w-full">
                    <div className="flex flex-col items-center justify-center w-full py-[45px] px-5 border-2 border-dark_bg_v4 border-dashed rounded-lg cursor-pointer bg-light_bg_v5 dark:bg-dark-secondary dark:border-color_dark hover:bg-gray-100 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                      <div className="flex flex-col items-center justify-center">
                        <div className="mb-[11px] h-[36px] w-[36]">
                          {darkMode ? (
                            <ImagePlacholderDark />
                          ) : (
                            <ImagePlacholder />
                          )}
                        </div>
                        <p className="text-small3 mb-[5px] lg:whitespace-nowrap text-center text-font_light_color dark:text-color_v1_dark">
                          {tComponent("imagegrid.drop_your_img")}, &nbsp;
                          <span className="text-small3_b text-main_color ">
                            {tComponent("imagegrid.browse_image")}
                          </span>
                        </p>
                        <p className="text-[10px] text-font_light_color dark:text-color_v1_dark tracking-[-0.3px] leading-[13px]">
                          2 MB {tComponent("imagegrid.maximum")}(.png, .gif,
                          .ico)
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              }
            />
          )}
          {files.length > 0 && (
            <div className="flex mt-3 items-center gap-[14px] flex-wrap">
              {files.map((file, i) => {
                return (
                  <div
                    key={i}
                    className="bg-light_bg_v4 rounded-lg cursor-pointer relative"
                  >
                    <div
                      onClick={() => removeImage(file)}
                      className="absolute cursor-pointer -right-2 -top-2 text-state_color_error text-lg"
                    >
                      <IoMdCloseCircle />
                    </div>
                    <img
                      className="h-[60px] w-[60px] sm:h-[64px] sm:w-[64px] p-1 object-cover rounded-lg"
                      src={URL.createObjectURL(file)}
                      alt=""
                    />
                  </div>
                );
              })}
            </div>
          )}
          <div className="flex mt-[26px] items-center justify-end">
            <div
              onClick={() => setFiles([])}
              className="flex justify-center items-center"
            >
              {darkMode ? <TrashIconDark /> : <TrashIcon />}
              <p className="ps-1.5 pt-1 text-small3_b gray-700 text-heading_color dark:text-color_v1_dark">
                {tComponent("imagegrid.delete_cap")}
              </p>
            </div>
            <button
              onClick={handleSubmit}
              className={`ms-3 rounded-full flex p-1.5 px-[22px] bg-main_color text-white text-small3_b ${
                imageLoading ? "opacity-70" : ""
              }`}
              disabled={imageLoading}
            >
              {imageLoading ? (
                <svg
                  aria-hidden="true"
                  role="status"
                  className="inline w-3 h-3 text-white animate-spin"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="#E5E7EB"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentColor"
                  />
                </svg>
              ) : (
                tComponent("imagegrid.save_cap")
              )}
            </button>
          </div>
        </div>
      </div>
    </>
    </I18nextProvider>
  );
};

export default ImageGrid;
